import React from 'react';
import { DynamicModuleLoader } from 'redux-dynamic-modules';
import { getEditorModule } from './module';

export interface Props {}

const EditorModuleLoader: React.FC<Props> = () => {
  return <DynamicModuleLoader modules={[getEditorModule()]} />;
};
EditorModuleLoader.displayName = 'EditorModuleLoader';

export default EditorModuleLoader;
